export default "__VITE_ASSET__TI6g26mW__"